import React, { useEffect, useState } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import icoUser from '../assets/img/ico-user.svg'

import './resumen.scss';
import { BarraPasos } from './BarraPasos';

export const Resumen = () => {

  const [numeroDocumento, setNumeroDocumento] = useState('');
  const [celular, setCelular] = useState('');
  const planName = localStorage.getItem('planName');
  const planPrice = localStorage.getItem('planPrice');

  useEffect(() => {
    const datosGuardados = localStorage.getItem('datosUsuario');
    if (datosGuardados) {
      const datos = JSON.parse(datosGuardados);      
      setNumeroDocumento(datos.numeroDocumento);
      setCelular(datos.celular);
    }
  }, []);

  return (
    <div className="wrapper wrapper_interna">
        <Header />
        <section className="seccion_principal">	
            <BarraPasos/>
            <section className="seccion_resumen">
                <div className="container">	
					          <h1>
                        Resumen del seguro 
                    </h1>

                    <article>
                        <div className="subtitulo">
                            Precios Calculados Para:
                        </div>
                        <div className="user">
                            <div className="ico">
                                <img src={icoUser} alt="Usuario" />
                            </div>
                            Rocio Miranda Díaz
                        </div>
                        <div className="caja_detalle c_responsable">
                            <strong>Responsable de pago</strong><br/>
                            <span>DNI: {numeroDocumento}</span> <br/>
                            <span>Celular: {celular}</span>
                        </div>
                        <div className="caja_detalle c_plan_elegido">
                            <strong>Plan elegido</strong><br/>
                            <span>{planName}</span> <br/>
                            <span>Costo del Plan: ${planPrice} al mes</span>
                        </div>


                    </article>
			            </div>
            </section>	
            			
		      </section>
        <Footer/>
    </div> 
  )
}
